<template>
  <div>
    <v-layout row>
      <v-flex md6>
        <Card tile flat class="pa-2">
          <div class="subheading try--text">{{ computedDowntimeInfo.name }}</div>
          <p class="caption lightText--text ma-0">
            {{ computedEnergyInfo.info }}
          </p>
          <div class="title pt-2">{{ totalCard['time loss']}}</div>
        </Card>
      </v-flex>
      <v-flex md6>
        <Card tile flat class="pa-2">
          <div class="subheading try--text">{{ computedEnergyInfo.name }}</div>
          <div class="caption lightText--text ma-0">
            {{ computedEnergyInfo.info }}
          </div>
          <div class="title pt-2">{{totalCard['energy loss']}}</div>
        </Card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    totalCard: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    computedEnergyInfo() {
      return {
        name: this.$t('Energy Loss'),
        info: this.$t('Calculated Energy loss when Solar PV plant is not generating power due to technical failures (Grid/Inverter). This Energy is calculated based on the irradiance value and inverter capacity')
      }
    },
    computedDowntimeInfo() {
      return {
        name: this.$t('Down Time'),
        info: this.$t('Time when the PV system cannot provide power to the load, downtime may be due to technical failure of the solar plant or maintenance of the solar plant.')
      }
    }
  }
}
</script>
